import { cardI, cardsType } from "./prodReducer";
import card1 from '../images/cards/card1.jpg'
import card2 from '../images/cards/card2.jpg'
import card3 from '../images/cards/card3.jpg'

import { citiesType, cityI } from "./worldMapReducer";
import BLRImage from '../images/cities/BLR.jpg'
import NoidaImage from '../images/cities/Noida.jpg'
import GurugramImage from '../images/cities/Gurugram.jpg'

import { benefitsType, jobI, stagesType } from "./jobsReducer";
import { allNewsType, newsI } from "./newsReducer";

import news1_1 from '../images/news/news1_1.jpg'
import news2_1 from '../images/news/news2_1.jpg'
import { teamType } from "./teamReducer";

import avatar1 from '../images/avatars/avatar1.jpg'
import avatar2 from '../images/avatars/avatar2.jpg'
import avatar3 from '../images/avatars/avatar3.jpg'
import { sponsorsType } from "./sponsorsReducer";

import adobe from '../images/sponsors/adobe.png'
import amazon from '../images/sponsors/amazon.png'
import apple from '../images/sponsors/apple.png'
import cisco from '../images/sponsors/cisco.png'
import digitalDinamics from '../images/sponsors/digitalDinamics.png'
import facebook from '../images/sponsors/facebook.png'
import futureTech from '../images/sponsors/futureTech.png'
import globalTech from '../images/sponsors/globalTech.png'
import megaSolutions from '../images/sponsors/megaSolutions.png'
import microsoft from '../images/sponsors/microsoft.png'
import quantumTech from '../images/sponsors/quantumTech.png'
import startSolutions from '../images/sponsors/startSolutions.png'
import techco from '../images/sponsors/techco.png'
import unity from '../images/sponsors/unity.png'
import netflix from '../images/sponsors/netflix.jpg'





const pc = 'fa-solid fa-desktop'
const mobile = 'fa-solid fa-mobile-screen-button'


export const uniqueTags = [
    'Web Services','Web Application', 'Artificial Intellingence', 'GPT', 'IoT','Open-source'
];


const firstProd: cardI = {
    id: 1,
    title: 'Reminisce',
    description: "Step into the world of 'Reminisce,' a heartwarming web-based application and answering machine designed to strengthen the bonds between patients with memory-related challenges and their loved ones. Through the power of storytelling and personal connections, 'Reminisce' aims to evoke cherished memories and create new ones, bridging the gap between past and present.",
    image: card1,
    tags: ['Memory Aid', 'Web Application', 'Storytelling', 'Personal Connections','IoT'],
    yearReleased: 2024,
    platforms: [pc, mobile]
}

const secondProd: cardI = {
    id: 2,
    title: 'PageCraft',
    description: "Introducing PageCraft, an open-source AI Landing Page Generator for everyone! This powerful tool harnesses the capabilities of artificial intelligence to enable quick and effortless creation of stunning landing pages. By automating the design and coding process, PageCraft saves you valuable time and effort, allowing you to focus on your core tasks.",
    image: card2,
    tags: ['GPT', 'Landing Page Generator', 'Open-source', 'Tailwind CSS'],
    yearReleased: 2024,
    platforms: [pc, mobile]
}

const thirdProd: cardI = {
    id: 3,
    title: 'TomatoWise',
    description: "TomatoWise is an innovative project aimed at revolutionizing tomato cultivation and addressing challenges in the agriculture sector. Led by Avirbhaav, TomatoWise leverages advanced technologies and data-driven insights to enhance crop yield, reduce wastage, and promote sustainable practices throughout the supply chain.",
    image: card3,
    tags: ['Agriculture', 'Innovation', 'Technology', 'Sustainability','IoT'],
    yearReleased: 2023,
    platforms: [pc, mobile]
}

export const cardsArray:cardsType = [
    firstProd, secondProd, thirdProd
]





const Noida:cityI = {
    name: "Greater Noida",
    description: 'Greater Noida, an emerging hub in the Delhi-NCR region, is gaining traction among startups and developers due to its strategic location, modern infrastructure, and growing opportunities in various sectors.',
    image: NoidaImage,
    left: "left-[55%] sm:left-[55%] lg:left-[55%]",
    top: 'top-[30%] sm:top-[32%] lg:top-[34%]'
}

const BLR:cityI = {
    name: 'Bangalore',
    description: 'Bangalore, known as the Silicon Valley of India, boasts a vibrant ecosystem for startups and developers, fostering innovation and technological advancement.',
    image: BLRImage,
    left: 'left-[52%]',
    top: 'top-[31%] sm:top-[33%] lg:top-[35%]'
}

const Gurugram: cityI = {
    name: 'Gurugram',
    description: 'Gurugram, a bustling city in India National Capital Region, attracts startups and developers with its cosmopolitan atmosphere, corporate presence, and access to a skilled workforce, making it a thriving hub for innovation and technology.',
    image: GurugramImage,
    left: 'left-[48%]',
    top: 'top-[32%] sm:top-[34%] lg:top-[36%]'
}


export const allCities: citiesType = [Noida,BLR,Gurugram]





const job1: jobI = {
    id: 1,
    position: 'UX/UI Designer',
    location: 'Noida / India',
    type: 'Remote'
};

const job2: jobI = {
    id: 2,
    position: 'Content Writer',
    location: 'Noida, India',
    type: 'Remote'
};

const job3: jobI = {
    id: 3,
    position: 'Marketing Specialist',
    location: 'Noida, India',
    type: 'Contract'
};

const job4: jobI = {
    id: 4,
    position: 'Data Scientist',
    location: 'Bangalore, India',
    type: 'Part-time'
};

export const allJobs = [job1, job2, job3, job4]
export const allJobsLocation = ['India']

export const allStages: stagesType = [
    {
        id: 1,
        title: 'Initial Screening',
        description: 'Your application will undergo a thorough evaluation by our experienced development team. If your qualifications align with the key requirements for the role, expect to hear from our Recruiters shortly! Explore our current career opportunities here.',
    },
    {
        id: 2,
        title: 'Initial Conversation',
        description: 'Embark on the first phase of our recruitment process with a discussion led by our dedicated recruitment team. Gain in-depth insights into avibhaav and the specific role you\'re applying for. This interaction also provides us with the opportunity to delve into your professional profile.',
    },
    {
        id: 3,
        title: 'Skills Demonstration',
        description: 'Progressing further, you\'ll be invited to demonstrate your skills in a more practical setting. This stage often involves a tailored test assignment, allowing us to witness your abilities in action and evaluate your aptitude for the role.',
    },
    {
        id: 4,
        title: 'Developer Interaction',
        description: 'For those who successfully navigate the skills assessment, the subsequent step involves direct interaction with our development team. This session delves deeper into your test results and professional experiences, providing a thorough understanding of your potential role.',
    },
    {
        id: 5,
        title: 'Final Discussion and Decision',
        description: 'Congratulations on reaching the final stage of our recruitment process! In this phase, you\'ll engage in a conclusive discussion with our HR team. Cover any remaining topics, address additional queries, and collectively decide if a collaborative journey with us is the next step. If the answer is affirmative, an offer will be extended, marking the beginning of your exciting journey with the Avirbhaavks!',
    },
];
  








const news1: newsI = {
    id: 1,
    date: "Jan 08",
    year: 2024,
    read: 2,
    images: [news1_1],
    title: "Avirbhaav's Idea Selected for development by Indian Goverment",
    subtitle: "Transforming agriculture with innovative solutions.",
    body: "Avirbhaav's groundbreaking project, 'TomatoWise,' has been selected as the winner of the Tomato Grand Challenge organized by the Department of Consumer Affairs, Ministry of Consumer Affairs, Food and Public Distribution, India. This achievement marks a significant milestone in the quest to revolutionize the agriculture sector.\n\nLed by Pritish and supported by an exceptional team, 'TomatoWise' aims to revolutionize tomato cultivation by leveraging advanced technologies and data-driven insights. The project focuses on enhancing crop yield, reducing wastage, and ensuring sustainable practices throughout the supply chain.\n\nThe culmination of months of hard work and dedication, the team's presentation at Raj Bhavan showcased the innovative features and potential impact of 'TomatoWise.' Speaking on behalf of the team, Pritish expressed gratitude for the opportunity and highlighted the project's mission:\n\n'Our project, 'TomatoWise' aims to make a meaningful impact in the agriculture sector. Kudos to the team's hard work and dedication!'\n\nAs 'TomatoWise' continues to gain recognition, Avirbhaav remains committed to driving positive change and fostering innovation in agriculture.",
    tags: ["Agriculture", "Innovation", "Technology"]
};

const news2: newsI = {
    id: 2,
    date: "Feb 24",
    year: 2024,
    read: 3,
    images: [news2_1],
    title: "Avirbhaav Wins OpenHack- Generative AI Hackathon",
    subtitle: "Empowering patients with memory-related challenges.",
    body: "Avirbhaav continues its winning streak with another remarkable victory at the OpenHack- Generative AI Hackathon organized by the Computer Science and Automation Department at the prestigious Indian Institute of Science (IISc). The team's project, 'Reminisce,' stood out for its innovative approach and impact.\n\nCoded under intense time constraints of 24 hours, 'Reminisce' is a powerful tool designed to help maintain and strengthen the bonds between patients with memory-related challenges and their loved ones. With the tagline 'Your memories, Our narration,' the project leverages the power of storytelling and personal connections to bridge the gap between past and present.\n\nFeaturing a web-based application and an answering machine, 'Reminisce' offers a range of features aimed at enhancing the quality of life for patients and their families:\n\n- Story Sharing: Users can share and read personal stories and favorite memories of the patient, creating a living tapestry of family history and experiences.\n- Profile Customization: Each patient's profile is customizable, allowing for a personalized experience tailored to their preferences and attributes. This customization also enhances storytelling effectiveness, as the model is trained on various user attributes.\n- Memory Aids: Through the use of images, familiar stories, and relationship mapping, 'Reminisce' assists patients in remembering their loved ones and cherished moments.\n- User-Friendly Interface: Designed with simplicity and ease of use in mind, the application is accessible to users of all ages, ensuring a seamless experience.\n\nAvirbhaav's win at the Generative AI Hackathon is a testament to their dedication and innovative spirit. With 'Reminisce,' they continue to make a meaningful impact in the lives of individuals facing memory-related challenges, fostering deeper connections and enriching experiences.",
    tags: ["Generative AI", "Hackathon", "Memory Aid", "Innovation"]
};

export const allUniqueNewsTags:Array<string> = [
"Technology",
"Generative AI",
"Hackathon",
"Community Event",
"Innovation",
"Enhancements",
"Team Expansion",
"Upcoming Product",
"Health"]

export const allNews: allNewsType = [news1, news2]



export const wholeTeam: teamType = [
    { id: 1, name: "Pritish Sinha", position: "Lead Developer", image:avatar1 },
    { id: 2, name: "Dikshant Tyagi", position: "Backend Designer", image:avatar2 },
    { id: 3, name: "Bhanu Priya", position: "QA Tester", image:avatar3 }
];





export const allSponsors: sponsorsType = [
    { id: 1, name: "TechCo", image: techco },
    { id: 2, name: "Microsoft", image: microsoft },
    { id: 3, name: "FutureTech", image: futureTech },
    { id: 4, name: "DigitalDynamics", image: digitalDinamics },
    { id: 5, name: "MegaSolutions", image: megaSolutions },
    { id: 6, name: "GlobalTech", image: globalTech },
    { id: 7, name: "Facebook", image: facebook },
    { id: 8, name: "Apple", image: apple },
    { id: 9, name: "StarSolutions", image: startSolutions },
    { id: 10, name: "Unity", image: unity },
    { id: 11, name: "Adobe", image: adobe },
    { id: 12, name: "Amazon", image: amazon },
    { id: 13, name: "Netflix", image: netflix },
    { id: 14, name: "QuantumTech", image: quantumTech },
    { id: 15, name: "Cisco", image: cisco },
  ];




export const allBenefits: benefitsType = [
    {id:1, icon: 'fa-solid fa-rocket', title: 'Innovation Hub', description: 'Avirbhaav fosters a dynamic and creative workspace where innovation is not just encouraged but celebrated. Team members have the opportunity to work on cutting-edge projects that redefine the tech industry.' },
    {id:2, icon: 'fa-solid fa-earth-americas', title: 'Global Reach', description: 'Join a team that creates tech solutions with a global impact. Avirbhaavks  work reaches audiences around the world, allowing employees to contribute to immersive experiences across diverse cultures.' },
    {id:3, icon: 'fa-solid fa-rainbow', title: 'Inclusive Culture', description: 'Avirbhaav values an inclusive culture where diversity is celebrated. Team members experience an environment that embraces different perspectives, creating a supportive and enriching workplace.' },
    {id:4, icon: 'fa-solid fa-book', title: 'Continuous Learning', description: 'Avirbhaav invests in the professional growth of its employees. Access to workshops, training programs, and industry events ensures that team members stay at the forefront of the rapidly evolving tech landscape.' },
    {id:5, icon: 'fa-solid fa-hand-spock', title: 'Talent Recognition', description: 'Exceptional talent is recognized and celebrated at Avirbhaav. Outstanding contributions are acknowledged, creating a culture where each team members unique skills are valued and appreciated.' },
    {id:6, icon: 'fa-regular fa-handshake', title: 'Collaborative Dynamics', description: 'Avirbhaav thrives on collaboration. Team members work seamlessly together, combining diverse skill sets to tackle challenges and create tech solutions that push the boundaries of innovation.' },
    {id:7, icon: 'fa-solid fa-scale-balanced', title: 'Work-Life Balance', description: 'Avirbhaav understands the importance of work-life balance. Flexible work schedules and a supportive environment enable employees to maintain a healthy equilibrium between professional and personal life.' },
    {id:8, icon: 'fa-solid fa-wand-magic-sparkles', title: 'Networking Opportunities', description: 'Working at Avirbhaav opens doors to a vast network of industry professionals. Employees have opportunities to connect, collaborate, and build relationships with experts and peers in the tech community.' },
    {id:9, icon: 'fa-regular fa-lightbulb', title: 'Creative Freedom', description: 'Avirbhaav empowers its team with creative freedom. Team members have the autonomy to explore innovative ideas, contributing to the development of tech solutions that stand out for their originality and creativity.' },
    {id:10, icon: 'fa-solid fa-coins', title: 'Recognition and Rewards', description: 'Avirbhaav values and rewards achievements. Whether its hitting project milestones or personal accomplishments, employees enjoy recognition and rewards that highlight their contributions to the team success.' }
];
  